export default __webpack_public_path__ + "static/playingChildren-5e7676be097168f42d00350b2c84ab45.webp";